/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: {},
	errors: [],
	activate: {},
};

const employeeProfileSlice = createSlice({
	name: 'employeeProfile',
	initialState,
	reducers: {
		fetchEmployeeProfile() {},
		fetchEmployeeProfileFulfilled(state, { payload }) {
			state.data = payload;
			state.errors = [];
			state.activate = {};
		},
		fetchEmployeeProfileFailed(state, { payload }) {
			state.errors = payload.errors || [];
			state.activate = {};
		},
		fetchEmployeeProfileCancel() {},

		setEmployeeActivateProfile(state, { payload = {} }) {
			state.data = {};
			state.errors = [];
			state.activate = {
				surname: payload.profile?.name?.surname,
				uniqueId: payload.profile?.uniqueId,
				salesForceId: payload.profile?.salesForceId,
			};
		},

		clearEmployeeProfile(state) {
			state.data = {};
			state.errors = [];
			state.activate = {};
		},
	},
});

export const {
	clearEmployeeProfile,
	fetchEmployeeProfile,
	fetchEmployeeProfileCancel,
	fetchEmployeeProfileFailed,
	fetchEmployeeProfileFulfilled,
	setEmployeeActivateProfile,
} = employeeProfileSlice.actions;

export default employeeProfileSlice.reducer;
